import React from 'react';

// Dashboard Icon
export const DashboardIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="DashboardIcon icon"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.49886 9.99783H7.49785C8.04776 9.99783 8.49768 9.54791 8.49768 8.998V0.999344C8.49768 0.449436 8.04776 -0.000488281 7.49785 -0.000488281H1.49886C0.948948 -0.000488281 0.499023 0.449436 0.499023 0.999344V8.998C0.499023 9.54791 0.948948 9.99783 1.49886 9.99783ZM1.49886 17.9965H7.49785C8.04776 17.9965 8.49768 17.5466 8.49768 16.9967V12.9973C8.49768 12.4474 8.04776 11.9975 7.49785 11.9975H1.49886C0.948948 11.9975 0.499023 12.4474 0.499023 12.9973V16.9967C0.499023 17.5466 0.948948 17.9965 1.49886 17.9965ZM11.4972 17.9965H17.4962C18.0461 17.9965 18.496 17.5466 18.496 16.9967V8.998C18.496 8.44809 18.0461 7.99817 17.4962 7.99817H11.4972C10.9473 7.99817 10.4973 8.44809 10.4973 8.998V16.9967C10.4973 17.5466 10.9473 17.9965 11.4972 17.9965ZM10.4973 0.999344V4.99867C10.4973 5.54858 10.9473 5.9985 11.4972 5.9985H17.4962C18.0461 5.9985 18.496 5.54858 18.496 4.99867V0.999344C18.496 0.449436 18.0461 -0.000488281 17.4962 -0.000488281H11.4972C10.9473 -0.000488281 10.4973 0.449436 10.4973 0.999344Z"
      fill="white"
    />
  </svg>
);

// QR Code Users Icon
export const QRCodeIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="QRCodeIcon icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.92857C0 0.863839 0.863839 0 1.92857 0H5.78571C6.85045 0 7.71429 0.863839 7.71429 1.92857V5.78571C7.71429 6.85045 6.85045 7.71429 5.78571 7.71429H1.92857C0.863839 7.71429 0 6.85045 0 5.78571V1.92857ZM2.57143 2.57143V5.14286H5.14286V2.57143H2.57143ZM0 12.2143C0 11.1496 0.863839 10.2857 1.92857 10.2857H5.78571C6.85045 10.2857 7.71429 11.1496 7.71429 12.2143V16.0714C7.71429 17.1362 6.85045 18 5.78571 18H1.92857C0.863839 18 0 17.1362 0 16.0714V12.2143ZM2.57143 12.8571V15.4286H5.14286V12.8571H2.57143ZM12.2143 0H16.0714C17.1362 0 18 0.863839 18 1.92857V5.78571C18 6.85045 17.1362 7.71429 16.0714 7.71429H12.2143C11.1496 7.71429 10.2857 6.85045 10.2857 5.78571V1.92857C10.2857 0.863839 11.1496 0 12.2143 0ZM15.4286 2.57143H12.8571V5.14286H15.4286V2.57143ZM10.2857 10.9286C10.2857 10.575 10.575 10.2857 10.9286 10.2857H13.5C13.8536 10.2857 14.1429 10.575 14.1429 10.9286C14.1429 11.2821 14.4321 11.5714 14.7857 11.5714H16.0714C16.425 11.5714 16.7143 11.2821 16.7143 10.9286C16.7143 10.575 17.0036 10.2857 17.3571 10.2857C17.7107 10.2857 18 10.575 18 10.9286V14.7857C18 15.1393 17.7107 15.4286 17.3571 15.4286H14.7857C14.4321 15.4286 14.1429 15.1393 14.1429 14.7857C14.1429 14.4321 13.8536 14.1429 13.5 14.1429C13.1464 14.1429 12.8571 14.4321 12.8571 14.7857V17.3571C12.8571 17.7107 12.5679 18 12.2143 18H10.9286C10.575 18 10.2857 17.7107 10.2857 17.3571V10.9286ZM14.7857 18C14.6152 18 14.4517 17.9323 14.3311 17.8117C14.2106 17.6912 14.1429 17.5276 14.1429 17.3571C14.1429 17.1866 14.2106 17.0231 14.3311 16.9026C14.4517 16.782 14.6152 16.7143 14.7857 16.7143C14.9562 16.7143 15.1197 16.782 15.2403 16.9026C15.3608 17.0231 15.4286 17.1866 15.4286 17.3571C15.4286 17.5276 15.3608 17.6912 15.2403 17.8117C15.1197 17.9323 14.9562 18 14.7857 18ZM17.3571 18C17.1866 18 17.0231 17.9323 16.9026 17.8117C16.782 17.6912 16.7143 17.5276 16.7143 17.3571C16.7143 17.1866 16.782 17.0231 16.9026 16.9026C17.0231 16.782 17.1866 16.7143 17.3571 16.7143C17.5276 16.7143 17.6912 16.782 17.8117 16.9026C17.9323 17.0231 18 17.1866 18 17.3571C18 17.5276 17.9323 17.6912 17.8117 17.8117C17.6912 17.9323 17.5276 18 17.3571 18Z"
      fill="white"
    />
  </svg>
);

// Campaign Icon
// Replace the existing CampaignIcon component with this version
export const CampaignIcon: React.FC<{ style?: React.CSSProperties }> = () => {
  const uid = React.useId();
  const _maskId = `campaign-mask-${uid}`;
  const _titleId = `campaign-title-${uid}`;

  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H13V7H4V12ZM14.5 9H16V4H7V5.5H14.5V9ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2Z"
        fill="white"
      />
    </svg>
  );
};

// Draw/Winners Icon
export const DrawIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="DrawIcon icon"
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 0.496094H6C5.17188 0.496094 4.49687 1.17734 4.52812 2.00234C4.53437 2.16797 4.54063 2.33359 4.55 2.49609H1.25C0.834375 2.49609 0.5 2.83047 0.5 3.24609C0.5 6.13984 1.54688 8.15234 2.95312 9.51797C4.3375 10.8648 6.025 11.543 7.26875 11.8867C8 12.0898 8.5 12.6992 8.5 13.3117C8.5 13.9648 7.96875 14.4961 7.31563 14.4961H6.5C5.94688 14.4961 5.5 14.943 5.5 15.4961C5.5 16.0492 5.94688 16.4961 6.5 16.4961H12.5C13.0531 16.4961 13.5 16.0492 13.5 15.4961C13.5 14.943 13.0531 14.4961 12.5 14.4961H11.6844C11.0312 14.4961 10.5 13.9648 10.5 13.3117C10.5 12.6992 10.9969 12.0867 11.7312 11.8867C12.9781 11.543 14.6656 10.8648 16.05 9.51797C17.4531 8.15234 18.5 6.13984 18.5 3.24609C18.5 2.83047 18.1656 2.49609 17.75 2.49609H14.45C14.4594 2.33359 14.4656 2.17109 14.4719 2.00234C14.5031 1.17734 13.8281 0.496094 13 0.496094ZM2.02813 3.99609H4.66563C4.95 6.81172 5.57812 8.69297 6.2875 9.95234C5.50938 9.60859 4.7 9.12422 4 8.44297C3 7.47109 2.1875 6.06797 2.03125 3.99609H2.02813ZM15.0031 8.44297C14.3031 9.12422 13.4937 9.60859 12.7156 9.95234C13.425 8.69297 14.0531 6.81172 14.3375 3.99609H16.975C16.8156 6.06797 16.0031 7.47109 15.0063 8.44297H15.0031Z"
      fill="white"
    />
  </svg>
);

// Retailers Icon
export const RetailersIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="RetailersIcon icon"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2V0H17V2H1ZM1 16V10H0V8L1 3H17L18 8V10H17V16H15V10H11V16H1ZM3 14H9V10H3V14Z"
      fill="white"
    />
  </svg>
);

// Distributors Icon
export const DistributorsIcon: React.FC<{
  style?: React.CSSProperties;
}> = () => (
  <svg
    role="img"
    aria-label="DistributorsIcon icon"
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 16C4.16667 16 3.45833 15.7083 2.875 15.125C2.29167 14.5417 2 13.8333 2 13H0V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16V4H19L22 8V13H20C20 13.8333 19.7083 14.5417 19.125 15.125C18.5417 15.7083 17.8333 16 17 16C16.1667 16 15.4583 15.7083 14.875 15.125C14.2917 14.5417 14 13.8333 14 13H8C8 13.8333 7.70833 14.5417 7.125 15.125C6.54167 15.7083 5.83333 16 5 16ZM5 14C5.28333 14 5.52083 13.9042 5.7125 13.7125C5.90417 13.5208 6 13.2833 6 13C6 12.7167 5.90417 12.4792 5.7125 12.2875C5.52083 12.0958 5.28333 12 5 12C4.71667 12 4.47917 12.0958 4.2875 12.2875C4.09583 12.4792 4 12.7167 4 13C4 13.2833 4.09583 13.5208 4.2875 13.7125C4.47917 13.9042 4.71667 14 5 14ZM17 14C17.2833 14 17.5208 13.9042 17.7125 13.7125C17.9042 13.5208 18 13.2833 18 13C18 12.7167 17.9042 12.4792 17.7125 12.2875C17.5208 12.0958 17.2833 12 17 12C16.7167 12 16.4792 12.0958 16.2875 12.2875C16.0958 12.4792 16 12.7167 16 13C16 13.2833 16.0958 13.5208 16.2875 13.7125C16.4792 13.9042 16.7167 14 17 14ZM16 9H20.25L18 6H16V9Z"
      fill="white"
    />
  </svg>
);

// User Management Icon
export const UserManagementIcon: React.FC<{
  style?: React.CSSProperties;
}> = () => (
  <svg
    role="img"
    aria-label="UserManagementIcon icon"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 13C13.1667 13 12.4583 12.7083 11.875 12.125C11.2917 11.5417 11 10.8333 11 10C11 9.16667 11.2917 8.45833 11.875 7.875C12.4583 7.29167 13.1667 7 14 7C14.8333 7 15.5417 7.29167 16.125 7.875C16.7083 8.45833 17 9.16667 17 10C17 10.8333 16.7083 11.5417 16.125 12.125C15.5417 12.7083 14.8333 13 14 13ZM8 20V17.1C8 16.75 8.08333 16.4208 8.25 16.1125C8.41667 15.8042 8.65 15.5583 8.95 15.375C9.48333 15.0583 10.0458 14.7958 10.6375 14.5875C11.2292 14.3792 11.8333 14.225 12.45 14.125L14 16L15.55 14.125C16.1667 14.225 16.7667 14.3792 17.35 14.5875C17.9333 14.7958 18.4917 15.0583 19.025 15.375C19.325 15.5583 19.5625 15.8042 19.7375 16.1125C19.9125 16.4208 20 16.75 20 17.1V20H8ZM6 17.1V18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V7C17.4833 6.35 16.9 5.85417 16.25 5.5125C15.6 5.17083 14.85 5 14 5V4H4V6H11C10.6667 6.26667 10.3667 6.56667 10.1 6.9C9.83333 7.23333 9.60833 7.6 9.425 8H4V10H9C9 10.35 9.0375 10.6917 9.1125 11.025C9.1875 11.3583 9.29167 11.6833 9.425 12H4V14H7.45C7 14.3833 6.64583 14.8458 6.3875 15.3875C6.12917 15.9292 6 16.5 6 17.1Z"
      fill="white"
    />
  </svg>
);

// Profile/Settings Icon
export const ProfileIcon: React.FC<{ style?: React.CSSProperties }> = ({
  style,
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={style}
    role="img"
    aria-label="icon"
  >
    {/* Replace with your SVG path */}
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
);

// Analytics Icon
export const AnalyticsIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="ProfileIcon icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 16V9H16V16H12ZM6 16V0H10V16H6ZM0 16V5H4V16H0Z" fill="white" />
  </svg>
);

// Orders Icon
export const OrdersIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="OrdersIcon icon"
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 15.9961H12.5V13.9961H4.5V15.9961ZM4.5 11.9961H12.5V9.99609H4.5V11.9961ZM2.5 19.9961C1.95 19.9961 1.47917 19.8003 1.0875 19.4086C0.695833 19.0169 0.5 18.5461 0.5 17.9961V1.99609C0.5 1.44609 0.695833 0.97526 1.0875 0.583594C1.47917 0.191927 1.95 -0.00390625 2.5 -0.00390625H10.5L16.5 5.99609V17.9961C16.5 18.5461 16.3042 19.0169 15.9125 19.4086C15.5208 19.8003 15.05 19.9961 14.5 19.9961H2.5ZM9.5 6.99609H14.5L9.5 1.99609V6.99609Z"
      fill="white"
    />
  </svg>
);

export const SettingsIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="SettingsIcon icon"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75 19.9961L7.35 16.7961C7.13333 16.7128 6.92916 16.6128 6.7375 16.4961C6.54583 16.3794 6.35833 16.2544 6.175 16.1211L3.2 17.3711L0.449997 12.6211L3.025 10.6711C3.00833 10.5544 3 10.4419 3 10.3336V9.65859C3 9.55026 3.00833 9.43776 3.025 9.32109L0.449997 7.37109L3.2 2.62109L6.175 3.87109C6.35833 3.73776 6.55 3.61276 6.75 3.49609C6.95 3.37943 7.15 3.27943 7.35 3.19609L7.75 -0.00390625H13.25L13.65 3.19609C13.8667 3.27943 14.0708 3.37943 14.2625 3.49609C14.4542 3.61276 14.6417 3.73776 14.825 3.87109L17.8 2.62109L20.55 7.37109L17.975 9.32109C17.9917 9.43776 18 9.55026 18 9.65859V10.3336C18 10.4419 17.9833 10.5544 17.95 10.6711L20.525 12.6211L17.775 17.3711L14.825 16.1211C14.6417 16.2544 14.45 16.3794 14.25 16.4961C14.05 16.6128 13.85 16.7128 13.65 16.7961L13.25 19.9961H7.75ZM10.55 13.4961C11.5167 13.4961 12.3417 13.1544 13.025 12.4711C13.7083 11.7878 14.05 10.9628 14.05 9.99609C14.05 9.02943 13.7083 8.20443 13.025 7.52109C12.3417 6.83776 11.5167 6.49609 10.55 6.49609C9.56666 6.49609 8.7375 6.83776 8.0625 7.52109C7.3875 8.20443 7.05 9.02943 7.05 9.99609C7.05 10.9628 7.3875 11.7878 8.0625 12.4711C8.7375 13.1544 9.56666 13.4961 10.55 13.4961Z"
      fill="white"
    />
  </svg>
);

export const InventoryIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    role="img"
    aria-label="InventoryIcon icon"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 19.7211V10.5711L0.5 5.94609V13.9711C0.5 14.3378 0.5875 14.6711 0.7625 14.9711C0.9375 15.2711 1.18333 15.5128 1.5 15.6961L8.5 19.7211ZM10.5 19.7211L17.5 15.6961C17.8167 15.5128 18.0625 15.2711 18.2375 14.9711C18.4125 14.6711 18.5 14.3378 18.5 13.9711V5.94609L10.5 10.5711V19.7211ZM14.475 5.97109L17.425 4.24609L10.5 0.271094C10.1833 0.0877604 9.85 -0.00390625 9.5 -0.00390625C9.15 -0.00390625 8.81667 0.0877604 8.5 0.271094L6.525 1.39609L14.475 5.97109ZM9.5 8.84609L12.475 7.14609L4.55 2.54609L1.55 4.27109L9.5 8.84609Z"
      fill="white"
    />
  </svg>
);

export const BrandsIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    className="lucide lucide-award-icon lucide-award"
  >
    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
    <circle cx="12" cy="8" r="6" />
  </svg>
);

export const ProductsIcon: React.FC<{ style?: React.CSSProperties }> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    className="lucide lucide-boxes-icon lucide-boxes"
  >
    <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z" />
    <path d="m7 16.5-4.74-2.85" />
    <path d="m7 16.5 5-3" />
    <path d="M7 16.5v5.17" />
    <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z" />
    <path d="m17 16.5-5-3" />
    <path d="m17 16.5 4.74-2.85" />
    <path d="M17 16.5v5.17" />
    <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z" />
    <path d="M12 8 7.26 5.15" />
    <path d="m12 8 4.74-2.85" />
    <path d="M12 13.5V8" />
  </svg>
);
